import { CALL_API2 } from "../Utils/const";
import { getAuthToken } from "../context/auth-context";

export async function getAllClientes() {
  const token = getAuthToken();
  const result = await fetch(`${CALL_API2}/cliente`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await result.json();

  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

export async function getClienteById(idCliente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API2}/cliente/${idCliente}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.result;
}

export async function getSearchClient(sqlQuery) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API2}/search-cliente?sqlQuery=${sqlQuery}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.result;
}

export async function saveCliente(clienteObject) {
  const token = getAuthToken();
  const { isNew, idCliente } = clienteObject;

  let urlSend = `${CALL_API2}/cliente`;
  let method = "POST";

  // Eliminar flag del body
  delete clienteObject.isNew;

  if (!isNew) {
    // UPDATE
    urlSend = `${urlSend}/${idCliente}`;
    method = "PUT";

    // IMPORTANTE: NO enviar idCliente en el body
    delete clienteObject.idCliente;
  }

  const result = await fetch(urlSend, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(clienteObject),
  });

  const data = await result.json();
  if (!result.ok) throw new Error(data.message);

  return data;
}


export async function deleteClient(idCliente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API2}/cliente/${idCliente}`, {
    headers: { Authorization: `Bearer ${token}` },
    method: "DELETE",
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.isDeleted;
}
export async function isClienteDuplicado({
  telefono = "",
  nombre = "",
  ruc = "",
  idCliente = null, // opcional
}) {
  const token = getAuthToken();

  const response = await fetch(`${CALL_API2}/clientes/check-duplicate`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      telefono,
      nombre,
      ruc,
      idCliente, // se enviará null si no viene
    }),
  });

  const data = await response.json();
  console.log(data);
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data; // true si hay colisión, false si está libre
}